import React, { useState } from "react";
import { Box, Menu, Typography, Divider, MenuItem, } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { ReactComponent as Escalation1 } from "../../../../../Assets/Icons/EscalationIcons/Escalation1.svg";
import { ReactComponent as Escalation2 } from "../../../../../Assets/Icons/EscalationIcons/Escalation2.svg";
import { ReactComponent as Escalation3 } from "../../../../../Assets/Icons/EscalationIcons/Escalation3.svg";
import { ReactComponent as EscalationOuter } from "../../../../../Assets/Icons/EscalationIcons/escalationOuter.svg";
import { IAddEscalationFuncParams, IOptions } from "../../../../../Models/applicationModels";
import styles from "./EscalationIconStyles.module.css";

interface EscalationIconsProps {
    record: Record<string, any>;
    escalationIds: string[];
    HandleAddEscalation: (params: IAddEscalationFuncParams) => Promise<void>;
    escalationNames: IOptions[]
}

const ICON_COMPONENTS: Record<string, React.ElementType> = {
    "9b85283b-e5b3-463a-95fd-339cccfc6188": Escalation1,
    "8a1d4743-d381-4cdc-909a-6cdd3ff39169": Escalation2,
    "7c9685b5-485c-41bc-97f1-3079c0afce65": Escalation3,
};

const EscalationIcons: React.FC<EscalationIconsProps> = (props) => {
    const {
        escalationIds,
        record,
        HandleAddEscalation,
        escalationNames
    } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const renderIcon = (id: string) => {
        const IconComponent = ICON_COMPONENTS[id];
        return IconComponent ? <IconComponent width={20} height={20} /> : null;
    };

    return (
        <>
        <IconButton onClick={handleClick} className={styles.outerBtn}>
            <Box className={styles.btnInnerCtn}>
                <EscalationOuter />
                <span>
                    {escalationIds.length}
                </span>
            </Box>
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            <Typography variant="subtitle1" className={styles.menuHeader}>Escalations</Typography>
            <Divider />
            {escalationIds.map((id) => {
                const name = escalationNames.find((e) => e.id === id);
                if (!name) return null;

                return (
                    <MenuItem
                        key={id}
                        onClick={async () => {
                            await HandleAddEscalation({
                                oppId: record.opportunityUid,
                                escalationId: id,
                                escalationName: name.name,
                                agencyName: record.tenantTitle,
                            });
                            handleClose();
                        }}
                        className={styles.menuItem}
                    >
                        {renderIcon(id)}
                        <Typography variant="body2">{name.name}</Typography>
                    </MenuItem>
                );
            })}
        </Menu>

        {/*<Box display="flex" gap={1} alignSelf="center">*/}
        {/*    {escalationIds.sort((a, b) => (a > b ? 1 : -1)).map((id) => {*/}
        {/*        const IconComponent = ICON_COMPONENTS[id];*/}
        {/*        if (!IconComponent) return null;*/}

        {/*        return (*/}
        {/*            <IconComponent*/}
        {/*                key={id}*/}
        {/*                width={24}*/}
        {/*                height={24}*/}
        {/*                style={{ cursor: "pointer" }}*/}
        {/*                onClick={async () => {*/}
        {/*                    const escalationName = escalationNames?.find(*/}
        {/*                        (item) => item.id === id*/}
        {/*                    ) ?? null;*/}
        {/*                    if(!escalationName){*/}
        {/*                        console.error("Escalation Name not found for id", id);*/}
        {/*                        return;*/}
        {/*                    }*/}

        {/*                    await HandleAddEscalation({*/}
        {/*                        oppId: record.opportunityUid,*/}
        {/*                        escalationId: id,*/}
        {/*                        escalationName: escalationName.name,*/}
        {/*                        agencyName: record.tenantTitle,*/}
        {/*                    });*/}
        {/*                }}*/}
        {/*            />*/}
        {/*        );*/}
        {/*    })}*/}
        {/*</Box>*/}
        </>
    );
};

export default EscalationIcons;
